import { z } from 'zod';
import { isoDate, oneOfNumbers, str } from '../../../navigation/searchParams';

/**
 * A preset number of UTC days, or `from=YYYY-MM-DD` (the daily email's link,
 * which the page answers as the seven days ending on that day), and the
 * tenant shown.
 */
export const platformCallQualitySearch = z.object({
  days: oneOfNumbers([7, 14, 30, 92]),
  from: isoDate,
  tenant: str,
});
